import { Injectable } from '@angular/core';
import * as moment from 'moment';
const datePattern = /(\b(\d{2}|\d{1})\s*([/]|[-]|[.])\s*(\d{2}|\d{1})\s*([/]|[-]|[.])\s*(20\d{2}|\d{2}))|((20\d{2}|\d{2}) *[-] *(\b(0?[1-9]|1[012])\b) *[-] *(0[1-9]|[12][0-9]|3[01]))|(\b(\d{2}|\d{1}) *(th|rd|st|nd)? *[-]?\s*((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?)\s*[-]?\s*(20\d{2}|\d{2}))|((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)? *(\d{2}|\d{1}) *(th|rd|st|nd)? *(20(d{2}|\d{2})))|(((Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)([a-zA-Z]*)?) * \b(\d{2}|\d{1})\b([,])? *(20\d{2}|\d{2}))/gi;
@Injectable({
  providedIn: 'root',
})
export class MomentService {
  // some testing code
  constructor() { }

  static datePattern() {
    return datePattern;
  }

  static midDate(inputDate: string, format: string = 'YYYY-MM-DD') {
    return moment.default(inputDate, format).format('MMM Do YY');
  }

  static isValidDate(date: string) {
    if (!date) return false;
    if (date && !date.match(datePattern)) return false;
    return moment.default(date).isValid();
  }

  static fullDateTime(inputDate: string, format: string = 'YYYY-MM-DDTHH:mm:ss') {
    // return moment.default(inputDate, format).format('MMM Do YY, h:mm:ss a');
    return moment.default(inputDate, format).format('MMM DD, YYYY hh:mm:ss');
  }
  static fullDateTimeDDMMYYYY(inputDate: string, format: string = 'YYYY-MM-DDTHH:mm:ss') {
    return moment.default(inputDate, format).format('DD/MM/yyyy');
  }

  static datetimeToDate(inputDateTime: string, inputFormat: string = 'YYYY-MM-DDTHH:mm:ss', outputFormat: string = 'YYYY-MM-DD') {
    return moment.default(inputDateTime, inputFormat).format(outputFormat);
  }

  static standardDateTime(inputDateTime: string, inputFormat: string = 'YYYY-MM-DDTHH:mm:ss') {
    return moment.default(inputDateTime, inputFormat);
  }

  static millisecToStandardDateTime(inputDateTime) {
    const date: any = new Date(inputDateTime);
    return this.fullDateTime(date);
  }

  static applyStandardDateFormat(date) {
    if (!date) return null;

    date = this.fixDateErrors(date);
    let a = date.match(/\d+st/);
    if (a) {
        // to fix 31st August 2020; contains 'st' twice
        a = a[0];
        const b = a.replace(/st/, '');
        date = date.replace(a, b);
    }
    date = date
        .replace(/th|nd|rd/i, '')
        .replace(/Monday|Mon|Tuesday|Tue|Wednesday|Wed|Thursday|Thu|Friday|Fri|Saturday|Sat|Sunday|Sun/ig, '')
        .replace(/,/g, '')
        .replace(/ {2,}/g, ' ').trim();
    return this.applyStandardDateFormatWithMatch(date, [
        'YYYY-MM-DD',
        'DD/MM/YYYY',
        'D/MM/YYYY',
        'DD/M/YYYY',
        'D/M/YYYY',
        'DD/MM/YY',
        'DDMMMYYYY',
        'DDMMMYY',
        'DMMMYYYY',
        'DD MMM YYYY',
        'D MMM YYYY',
        'DD MMM YY',
        'D MMM YY',
        'DD-MM-YYYY',
        'DD-MMM-YYYY',
        'D-MMM-YYYY',
        'DD-MMM-YY',
        'D-MMM-YY',
        'DD-MMMM-YYYY',
        'D-MMMM-YYYY',
        'DD MMMM YYYY',
        'D MMMM YYYY',
        'MMMM DD YYYY',
        'MMM DD YYYY',
        'MMM D YYYY',
    ]);
  }

  static applyStandardDateFormatWithMatch(date, matchDateFormats) {
    if (!date) {
        return null;
    }
    date = date.replace(/\s[-]\s/g, '-');
    date = moment.default(date, matchDateFormats, true).format('YYYY-MM-DD');
    if (date === 'Invalid date') {
        return null;
    } else {
        return date;
    }
  }

  static fixDateErrors (dateString) {
    if (!dateString) return null;
    // remove symbol [-] from date
    if (dateString && dateString.match(/[-]/) && dateString.match(/[-]/g).length !== 2) {
      dateString = dateString.replace(/[-]/g, ' ');
    }

    const dateSplit = dateString ? dateString.split(' ') : [];
    if (dateSplit.length > 0 && dateSplit[0].length === 4) {
      const year = dateSplit[0];
      dateSplit.shift();
      dateString = dateSplit.toString() + ' ' + year;
      dateString = dateString.replace(/[,]/g, ' ');
    }

    // addSpaceIfNumberAndStringTogether
    if (dateString) {
      const regex = /(\d+)([a-zA-Z]+)(\d+)|(\d+)([a-zA-Z]+)|([a-zA-Z]+)(\d+)/g;

      // Use the replace function to add spaces between the number and string
      dateString = dateString.replace(regex, (match, p1, p2, p3, p4, p5, p6, p7) => {
        // Check which group is matched and add spaces accordingly
        if (p1 !== undefined && p2 !== undefined && p3 !== undefined) {
          return `${p1} ${p2} ${p3}`;
        } else if (p4 !== undefined && p5 !== undefined) {
          return `${p4} ${p5}`;
        } else if (p6 !== undefined) {
          return `${p6} ${p7}`;
        }
      });
    }
    return dateString;
  }
}
